"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hex6ToHex3;

function hex6ToHex3(value) {
  var r = value[1];
  var g = value[3];
  var b = value[5];

  if (r === value[2] && g === value[4] && b === value[6]) {
    return "#".concat(r).concat(g).concat(b);
  }

  return value;
}